"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = require("react-emotion");

var _styleConsts = require("../utils/styleConsts");

// import { hover, active } from 'glamor';
// fill: ${active ? theme.color.accentClicked : theme.color.grey1};
var label = function label(theme, warning, error, type, focus) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)(_styleConsts.buttonReset, "\n  position:relative;min-width:100%;min-height:", type === 'small' ? _styleConsts.height.medium : _styleConsts.height.large, ";", type === 'small' ?
    /*#__PURE__*/
    (0, _reactEmotion.css)("padding:7px 0px;") :
    /*#__PURE__*/
    (0, _reactEmotion.css)("padding:8px 0px;"), ";border-bottom:1px solid ", theme.color.grey2, ";outline:none;fill:", theme.color.grey1, ";color:", theme.color.grey1, ";& .IconSearch{", type === 'small' ? 'width: 16px; height: 16px;' : '', ";margin-right:11px;align-self:center;}&::after{left:0;width:0px;bottom:-1px;content:\"\";position:absolute;transition:all 0.3s ease;border-bottom:1px solid ", theme.color.accent, ";pointer-events:none;", focus && !error && !warning &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("width:100%;"), ";}&::before{left:0;right:0;bottom:-1px;content:\"\";position:absolute;transition:border-bottom-color 200ms cubic-bezier(0.4,0,0.2,1) 0ms;border-bottom:1px solid transparent;pointer-events:none;", focus && !error && !warning &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("border-bottom:0px;"), ";}&:hover{&::before{", !focus && !error && !warning && "\n        border-bottom: 1px solid ".concat(theme.color.black3, ";\n      "), ";}", !focus && !warning && !error && "\n      fill: ".concat(theme.color.black3, ";\n    "), "\n    ", focus && !warning && !error && "\n      fill: ".concat(theme.color.accent, ";\n    "), "}", warning && "\n    border-color: ".concat(theme.color.yellow, " !important;\n    color: ").concat(theme.color.yellow, ";\n  "), "\n  \n  ", error && "\n    border-color: ".concat(theme.color.red, " !important;\n    color: ").concat(theme.color.red, ";\n  "), "\n\n  ", focus && !warning && !error && "\n    fill: ".concat(theme.color.accent, ";\n  "))
  );
};

var input = function input(theme, type) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("height:", type === 'small' ? _styleConsts.height.small : _styleConsts.height.medium, ";outline:none;padding:0;", type === 'small' ? 'font-size: 12px' : '', ";&::placeholder{color:", theme.color.black3, ";}&:focus::placeholder{color:", theme.color.black3, ";}")
  );
};

var textarea = function textarea() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:block;box-sizing:border-box;width:100%;border:0;background:transparent;resize:none;outline:none;font-size:", _styleConsts.font.size.large, ";cursor:pointer;")
  );
};

var span = function span() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:absolute;bottom:-24px;left:0;font-size:", _styleConsts.font.size.medium, ";")
  );
};

var _default = {
  label: label,
  input: input,
  span: span,
  textarea: textarea
};
exports.default = _default;